import { Break } from '@helios/state-management'

/**
 *
 */
export function getBreakPositionSecurityId(
  issue: Break | undefined,
): number | undefined {
  const positionSecurityId =
    getMetadataJson(issue, 'Position Id')?.securityId ??
    getMetadataInt(issue, 'Security Id')

  return positionSecurityId
}

/**
 *
 */
export function getBreakSecurityId(
  issue: Break | undefined,
): number | undefined {
  return getMetadataInt(issue, 'Security Id')
}

/**
 *
 */
export function getBreakAccountId(
  issue: Break | undefined,
): number | undefined {
  return getMetadataInt(issue, 'accountId')
}

/**
 *
 */
export function getBreakAssetId(issue: Break | undefined): string | undefined {
  return getMetadataString(issue, 'Cusip')
}

/**
 *
 */
export function getBreakTransactionId(
  issue: Break | undefined,
): number | undefined {
  const id = getMetadataInt(issue, 'Transaction Id')
  if (!id) {
    return getMetadataInt(issue, 'origTranId')
  }
  return id
}

/**
 *
 */
export function getBreaksCwTransactionIds(
  issues: Break[] | undefined,
): number[] | undefined {
  if (!issues) return undefined
  const ids: number[] = []
  issues.forEach(issue => {
    const id = getMetadataInt(issue, 'Transaction Id')
    if (id) ids.push(id)
  })
  return ids
}

/**
 *
 */
export function getBreakExtTranId(
  issue: Break | undefined,
): number | undefined {
  return getMetadataInt(issue, 'External Tran Id')
}

/**
 *
 */
export function getBreaksExtTransactionIds(
  issues: Break[] | undefined,
): number[] | undefined {
  if (!issues) return undefined
  const ids: number[] = []
  issues.forEach(issue => {
    const id = getBreakExtTranId(issue)
    if (id) ids.push(id)
  })
  return ids
}

/**
 *
 */
export function getBreakExtTransactionId(
  issue: Break | undefined,
): number | undefined {
  return getMetadataInt(issue, 'External Transaction Id')
}

/**
 *
 */
function getMetadataInt(
  issue: Break | undefined,
  key: string,
): number | undefined {
  if (!issue) return undefined

  let value: string | undefined

  // As we transition to the new metadata format, we need to support both the old and new formats.
  if (Array.isArray(issue.metaData)) {
    value = issue.metaData.find(x => x.label === key)?.value
  } else {
    value = issue.metaData[key] as string
  }

  if (!value) return undefined
  return parseInt(value)
}

/**
 *
 */
function getMetadataString(
  issue: Break | undefined,
  key: string,
): string | undefined {
  if (!issue) return undefined

  let value: string | undefined
  // As we transition to the new metadata format, we need to support both the old and new formats.
  if (Array.isArray(issue.metaData)) {
    value = issue.metaData.find(x => x.label === key)?.value
  } else {
    value = issue.metaData[key] as string
  }

  if (!value) return undefined
  return value
}

/**
 *
 */
function getMetadataJson(
  issue: Break | undefined,
  key: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any | undefined {
  if (!issue) return undefined

  let value: string | undefined
  // As we transition to the new metadata format, we need to support both the old and new formats.
  if (Array.isArray(issue.metaData)) {
    value = issue.metaData.find(x => x.label === key)?.value
  } else {
    value = issue.metaData[key] as string
  }

  if (!value) return undefined
  try {
    return JSON.parse(value)
  } catch (e) {
    console.error(
      `unable to parse break metadata, key: ${key}, value: ${value}`,
    )
    return undefined
  }
}
